module.exports = "<div class=\"container\">\n  <div *ngIf=\"!isLogged()\">\n    <app-landingpage></app-landingpage>\n  </div>\n\n  <div *ngIf=\"isLogged()\">\n    <p>\n      Welcome to Join On Board\n    </p>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/homepage/homepage.component.html
// module id = 221
// module chunks = 1